import { watchExecuteSearch } from './executeSearch'

const searchSagas = [watchExecuteSearch]

export default searchSagas
